// 模块控制
import * as React from 'react'
import HomeConfigurationModule from '../HomeConfigurationModule/HomeConfigurationModule'
import HomeType from '../../types/HomeType'

interface HomeModuleControllerProps {
    content: HomeType.Module[]
}

function HomeModuleController(props: HomeModuleControllerProps) {
    return (
        <div className="HomeModuleController">
                <HomeConfigurationModule content={props.content}/>
        </div>
    )
}

export default HomeModuleController



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeModuleController/HomeModuleController.tsx